import {
  DashboardEnquirerStatsResponse,
  DashboardAssetOwnerStatsResponse,
  DashboardDBYDStatsResponse,
  DashboardUISelectionState
} from 'types';
interface ActionType {
  GET_DASHBOARD_ENQUIRER_STATS_START: string;
  GET_DASHBOARD_ENQUIRER_STATS_SUCCESS: string;
  GET_DASHBOARD_ENQUIRER_STATS_FAILURE: string;
  GET_DASHBOARD_ASSETONWER_STATS_START: string;
  GET_DASHBOARD_ASSETONWER_STATS_SUCCESS: string;
  GET_DASHBOARD_ASSETONWER_STATS_FAILURE: string;
  GET_DASHBOARD_DBYD_STATS_START: string;
  GET_DASHBOARD_DBYD_STATS_SUCCESS: string;
  GET_DASHBOARD_DBYD_STATS_FAILURE: string;
  RESET_DASHBOARD_STATE: string;
  SET_DASHBOARD_UI_STATE_RANGE_TEXT: string;
  SET_DASHBOARD_UI_STATE_SHOW_SHAPE: string;
  SET_DASHBOARD_UI_STATE_SHOW_GRID: string;
  SET_DASHBOARD_UI_STATE_SHOW_POINT: string;
  SET_DASHBOARD_UI_STATE_ADMIN_RANGE_TEXT: string;
}

export const DashboardActionTypes: ActionType = {
  GET_DASHBOARD_ENQUIRER_STATS_START: '@@GET_DASHBOARD_ENQUIRER_STATS_START',
  GET_DASHBOARD_ENQUIRER_STATS_SUCCESS:
    '@@GET_DASHBOARD_ENQUIRER_STATS_SUCCESS',
  GET_DASHBOARD_ENQUIRER_STATS_FAILURE:
    '@@GET_DASHBOARD_ENQUIRER_STATS_FAILURE',
  GET_DASHBOARD_ASSETONWER_STATS_START:
    '@@GET_DASHBOARD_ASSETONWER_STATS_START',
  GET_DASHBOARD_ASSETONWER_STATS_SUCCESS:
    '@@GET_DASHBOARD_ASSETONWER_STATS_SUCCESS',
  GET_DASHBOARD_ASSETONWER_STATS_FAILURE:
    '@@GET_DASHBOARD_ASSETONWER_STATS_FAILURE',
  GET_DASHBOARD_DBYD_STATS_START: '@@GET_DASHBOARD_DBYD_STATS_START',
  GET_DASHBOARD_DBYD_STATS_SUCCESS: '@@GET_DASHBOARD_DBYD_STATS_SUCCESS',
  GET_DASHBOARD_DBYD_STATS_FAILURE: '@@GET_DASHBOARD_DBYD_STATS_FAILURE',
  RESET_DASHBOARD_STATE: '@@RESET_DASHBOARD_STATE',
  SET_DASHBOARD_UI_STATE_RANGE_TEXT: '@@SET_DASHBOARD_UI_STATE_RANGE_STATE',
  SET_DASHBOARD_UI_STATE_SHOW_SHAPE: '@@SET_DASHBOARD_UI_STATE_SHOW_SHAPE',
  SET_DASHBOARD_UI_STATE_SHOW_GRID: '@@SET_DASHBOARD_UI_STATE_SHOW_GRID',
  SET_DASHBOARD_UI_STATE_SHOW_POINT: '@@SET_DASHBOARD_UI_STATE_SHOW_POINT',
  SET_DASHBOARD_UI_STATE_ADMIN_RANGE_TEXT:
    '@@SET_DASHBOARD_UI_STATE_ADMIN_RANGE_TEXT'
};

export interface DashboardState {
  enquirerStats?: DashboardEnquirerStatsResponse | string;
  assetOwnerStats?: DashboardAssetOwnerStatsResponse | string;
  dbydStats?: DashboardDBYDStatsResponse | string;
  uiSelectionState?: DashboardUISelectionState;
}
